import { useState } from "react";
import { useScrolled } from "@/hooks/useScrolled";
import { useSiteTheme } from "@/hooks/useSiteTheme";
import { cn } from "@/lib/utils";

interface NavProps {
  onOpenAuth: () => void;
}

const LINKS = [
  { href: "#market", label: "应用市场" },
  { href: "#vision", label: "愿景" },
  { href: "#how", label: "工作方式" },
  { href: "#faq", label: "常见问题" },
];

export function Nav({ onOpenAuth }: NavProps) {
  const scrolled = useScrolled();
  const { theme, toggle } = useSiteTheme();
  const [open, setOpen] = useState(false);

  return (
    <nav className={cn("nav", scrolled && "scrolled")} id="nav">
      <div className="container nav-inner">
        <a href="#" className="nav-logo" aria-label="Agentfly">
          <Logo />
          <span>Agentfly</span>
        </a>
        <ul className={cn("nav-links", open && "open")}>
          {LINKS.map((link) => (
            <li key={link.href}>
              <a href={link.href} onClick={() => setOpen(false)}>
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <button
              className="nav-theme-toggle"
              type="button"
              aria-label={theme === "light" ? "切换到深色模式" : "切换到浅色模式"}
              aria-pressed={theme === "light"}
              onClick={toggle}
            >
              <span className="nav-theme-icon" aria-hidden="true">
                {theme === "light" ? <SunIcon /> : <MoonIcon />}
              </span>
            </button>
          </li>
          <li>
            <a
              href="#console"
              className="nav-cta"
              onClick={(ev) => {
                ev.preventDefault();
                setOpen(false);
                onOpenAuth();
              }}
            >
              控制台 →
            </a>
          </li>
        </ul>
        <button
          className={cn("nav-hamburger", open && "open")}
          id="nav-hamburger"
          aria-label="切换菜单"
          onClick={() => setOpen((v) => !v)}
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}

export function Logo() {
  return (
    <svg className="nav-logo-icon" viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="navLogoG" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00e5a0" />
          <stop offset="50%" stopColor="#00b4d8" />
          <stop offset="100%" stopColor="#7b61ff" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#navLogoG)" />
      <path
        d="M 18 50 L 32 16 L 46 50 M 23 38 L 41 38"
        stroke="#0a0a0f"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="M4.93 4.93l1.41 1.41" />
      <path d="M17.66 17.66l1.41 1.41" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="M4.93 19.07l1.41-1.41" />
      <path d="M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.5A8.5 8.5 0 1 1 11.5 3a6.5 6.5 0 0 0 9.5 9.5z" />
    </svg>
  );
}
